import Marquee from "react-fast-marquee";
import { useLang } from "../LanguageContext";

export const MarqueeStrip = () => {
  const { t } = useLang();
  return (
    <div data-testid="marquee-strip" className="py-8 border-y border-white/10 bg-[#080808]">
      <Marquee speed={40} gradient gradientColor="#080808" gradientWidth={120}>
        {t.marquee.map((item, i) => (
          <div key={i} className="flex items-center gap-16 mx-8">
            <span className="marquee-item text-3xl md:text-5xl text-white/25 font-medium italic">{item}</span>
            <span className="text-[#d4af37] text-2xl">&#10022;</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
